export default {
  modelName: 'effect',
  label: '法規風險燈號',
  fields: {
    area: {
      label: '適用地區',
      type: 'belongsTo',
      textKey: 'name',
      modelName: 'area',
      rules: 'required',
      width: '150px',
      clearable: true,
    },
    icon: {
      type: 'image',
      label: 'Icon',
      uploadUrl: '/effect/icon/',
      maxWidth: '100px',
    },
    locales: {
      type: 'locales',
      fields: {
        name: {
          type: 'text',
          label: '名稱',
          autofocus: true,
          rules: 'required',
          maxlength: 100,
        },
      },
    },
    name: {
      type: 'text',
      label: '名稱',
      readonly: true,
    },
    sequence: {
      type: 'text',
      label: '排序',
      maxlength: 10,
    },

    updated_at: {
      type: 'datetime',
      label: '最後更新時間',
      readonly: true,
    },
    updated_admin: {
      type: 'belongsTo',
      label: '最後更新人',
      readonly: true,
      textKey: 'name',
      modeldataName: 'admin',
    },
    // updated_info: {
    //   type: "custom",
    //   label: "上次修改時間",
    //   getValue: (item) => {
    //     let _value = item.updated_at;
    //     if (item.updated_admin) {
    //       _value += `  ${item.updated_admin}`;
    //     }
    //     return _value;
    //   },
    // },
  },
};
